<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.user") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >

                    <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row">


                        <div class="col-lg-3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                            >
                            </base-input>
                        </div>

						<div class="col-md-2">
							<base-input>
								<el-select
									v-model="filterStatus"
									:placeholder="$t('status')"
									filterable
								>
									<el-option
										v-for="option in StatusTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-2">
							<base-input>
								<el-select
									v-model="filterGroup"
									:placeholder="$t('user_group')"
									filterable
								>
									<el-option
										v-for="option in UserGroupTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>


						</div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
							<el-table-column :label="$t('name')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.fname + " " + row.lname }} 
								</div>
							</el-table-column>

							<el-table-column :label="$t('nick_name')">
								<div slot-scope="{ row }" class="d-flex" >
									{{  row.nick_name }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('email')">
								<div slot-scope="{ row }" class="d-flex" >
									{{row.email }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('phone')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.phone }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('user.type')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ GetUserTypeName(row.group_id) }}
								</div>
							</el-table-column>


							<el-table-column :label="$t('sale_channel')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ GetSaleChannel(row.sale_channel_id) }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('department')">
								<div slot-scope="{ row }" class="d-flex" >
									 {{ GetDeaprtmentName(row.department_id) }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('status')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ GetStatusName(row.status) }}
								</div>
							</el-table-column>


                            <el-table-column
                                min-width="200px"
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
									<base-button
                                        @click.native="handleChangePassword($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-key"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >
				<form class="new-event--form" @submit.prevent="saveEvent">
					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('fname')" :name="$t('fname')" v-model="params.fname" rules="required"> </base-input>
						</div>
						<div class="col-md-6">
							<base-input :label="$t('lname')" :name="$t('lname')" v-model="params.lname" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('nick_name')" :name="$t('nick_name')" v-model="params.nick_name" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<!-- email -->
							<base-input :label="$t('email')" :name="$t('email')" v-model="params.email" rules="required|email"> </base-input>
						</div>

						<div class="col-md-6">
							<!-- phone -->
							<base-input :label="$t('phone')" :name="$t('phone')" v-model="params.phone" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<!-- Team select -->
							<base-input :label="$t('team')" >
								<el-select v-model="params.team_id" :placeholder="$t('team')" filterable >
									<el-option
										v-for="option in TeamTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-6">
							<!-- sale channel -->
							<base-input :label="$t('sale_channel')" >
								<el-select v-model="params.sale_channel_id" :placeholder="$t('sale_channel')" filterable >
									<el-option
										v-for="option in SaleChannelTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<!-- Department -->
							<base-input :label="$t('department')" >
								<el-select v-model="params.department_id" :placeholder="$t('department')" filterable >
									<el-option
										v-for="option in DepartmentTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-6">
							<!-- Department -->
							<base-input :label="$t('user_group')" >
								<el-select v-model="params.group_id" :placeholder="$t('user_group')" filterable >
									<el-option
										v-for="option in UserGroupTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>
					
					<div class="row">
						<div class="col-md-12">
							<!-- Department -->
							<base-input :label="$t('wms.storage_name')" >
								<el-select v-model="params.wms_storage_id" :placeholder="$t('wms.storage_name')" filterable >
									<el-option
										v-for="option in StorageTable"
										:key="option.ID"
										:label="option.Name"
										:value="option.ID"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- Department -->
							<base-input :label="$t('status')" >
								<el-select v-model="params.status" :placeholder="$t('status')" filterable >
									<el-option
										v-for="option in StatusTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<!-- Department -->
							
							<base-checkbox v-model="roles.order">รายการสั่งซื้อ</base-checkbox>
							<base-checkbox v-model="roles.packing">การจัดส่ง</base-checkbox>
							<base-checkbox v-model="roles.payment">ตรวจสอบชำระเงิน</base-checkbox>
							<base-checkbox v-model="roles.wms">คลังสินค้า</base-checkbox>
							<base-checkbox v-model="roles.platfrom">Platform</base-checkbox>
							<base-checkbox v-model="roles.report">รายงาน</base-checkbox>
							<base-checkbox v-model="roles.product">สินค้าและโปรโมชั่น</base-checkbox>
							<base-checkbox v-model="roles.order_return">สินค้าตีกลับ</base-checkbox>
							<!-- <base-checkbox v-model="roles.delivery">ระบบขนส่ง</base-checkbox> -->
						</div>
					</div>

					
				
				</form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

		<!-- Modal Change Password -->
		<modal :show.sync="showChangePasswordModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidatorPassword" >
				<form class="new-event--form" @submit.prevent="saveEvent">

					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('email')" :name="$t('email')" :value="params.email" rules="required|min:6"> </base-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('password')" :name="$t('password')" v-model="params_password.password" rules="required|min:6"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('password_confirm')" :name="$t('password_confirm')" v-model="params_password.password_confirm" rules="required"> </base-input>
						</div>
					</div>
				</form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-primary"
                    @click="handleUpdatePassword()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showChangePasswordModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

    </div>
</template>
<script>
import { Table, TableColumn, Select, Option,Checkbox } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
		Checkbox
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "User/getData",
			StorageTable: "WmsStorage/getDataWithAll",
			DepartmentTable: "Department/getData",
			TeamTable: "Team/getData",
			SaleChannelTable: "SaleChannel/getData",
			UserTypeTable: "User/getGroupTable",
        }),
		tableData: function() {
			let data = this.tableDataOrg
			if(this.filterStatus != 0){
				data = data.filter(x => x.status == this.filterStatus)
			}
			if(this.filterGroup != 0){
				data = data.filter(x => x.group_id == this.filterGroup)
			}
			return data
		}
    },
    data() {
        return {
            propsToSearch: ["fname", "lname", "nick_name", "email", "phone"],
            selectedRows: [],
            showAddModal: false,
			filterGroup: 0,
			filterStatus:0,
			roles :{
				order: false,
				packing: false,	
				payment: false,
				wms: false,
				platfrom: false,
				report: false,
				product: false,
				delivery: false,
				order_return:false,
			},
			id:0,
			showChangePasswordModal:false,
			params_password : {
				password : "",
				password_confirm : "",
			},
			params:{
				fname : "",
				lname : "",
				nick_name : "",
				email : "",
				active : 1,
				group_id : 1,
				phone : "",
				address : "",
				district_id : "",
				city_id : "",
				province_id : "",
				zipcode : "",
				password : "",
				department_id : 1,
				team_id : 1,
				roles : "",
				sale_channel_id:1,
				status:2,
				wms_storage_id:0,
			},
			RoleTypeTable: [
				{ "id": 0,"name": "None" },
				{ "id": 1,"name": "Read" },
				{ "id": 2,"name": "Write" },
				{ "id": 4,"name": "Delete" },
				{ "id": 7,"name": "All" }
			],
			UserGroupTable:[
				{ "id": 1,"name": "Admin" },
				{ "id": 2,"name": "ผู้บริหาร" },
				{ "id": 3,"name": "พนักงาน" },
				{ "id": 4,"name": "ตัวแทน" },
				{ "id": 5,"name": "ขนส่ง" },
				{ "id": 6,"name": "ลูกค้า" },
			],
			UserGroupTableWithAll:[
				{ "id": 0,"name": "--- กลุ่มผู้ใช้งาน ---" },
				{ "id": 1,"name": "Admin" },
				{ "id": 2,"name": "ผู้บริหาร" },
				{ "id": 3,"name": "พนักงาน" },
				{ "id": 4,"name": "ตัวแทน" },
				{ "id": 5,"name": "ขนส่ง" },
				{ "id": 6,"name": "ลูกค้า" },
			],
			StatusTable:[
				{ "id": 2,"name": "ใช้งาน" },
				{ "id": 3,"name": "ไม่ใช้งาน" },
			],
			StatusTableWithAll:[
				{ "id": 0,"name": "--- สถานะ ---" },
				{ "id": 2,"name": "ใช้งาน" },
				{ "id": 3,"name": "ไม่ใช้งาน" },
			]
        };
    },
    mounted() {
        this.listData();
		this.listDepartment();
		this.listSaleChannel();
		this.listTeam();
		this.listStorage();
    },
    methods: {
        ...mapActions({
            createData: "User/createData",
            updateData: "User/updateData",
            deleteData: "User/deleteData",
            listData: "User/listData",
			listDepartment: "Department/listData",
			listTeam: "Team/listData",
			listSaleChannel: "SaleChannel/listData",
            listStorage: "WmsStorage/listData",
			changePassword:"User/changePassword",
        }),
        handleCreate(action) {
            this.showAddModal = true;
			this.id=0;
			this.params.fname =  ""
			this.params.lname =  ""
			this.params.nick_name =  ""
			this.params.email =  ""
			this.params.active =  1
			this.params.group_id =  1
			this.params.phone =  ""
			this.params.address =  ""
			this.params.district_id =  ""
			this.params.city_id =  ""
			this.params.province_id =  ""
			this.params.zipcode =  ""
			this.params.password =  ""
			this.params.department_id =  1
			this.params.team_id =  1
			this.params.roles =  ""
			this.params.sale_channel_id = 1
			this.params.wms_storage_id = 0
        },
        handleEdit(index, row) {
            this.showAddModal = true;
            this.id = row.UserID
            this.params.fname = row.fname
            this.params.lname = row.lname
            this.params.nick_name = row.nick_name
            this.params.email = row.email
            this.params.active = row.active
            this.params.group_id = row.group_id
            this.params.phone = row.phone
            this.params.address = row.address
            this.params.district_id = row.district_id
            this.params.city_id = row.city_id
            this.params.province_id = row.province_id
            this.params.zipcode = row.zipcode
            this.params.department_id = row.department_id
            this.params.team_id = row.team_id
            this.params.roles = row.roles
            this.params.sale_channel_id = row.sale_channel_id
            this.params.status = row.status
			this.params.wms_storage_id = row.wms_storage_id

			// fetch roles
			let r = JSON.parse(this.params.roles)
			this.roles.order = r.order == 0 ? false : true
			this.roles.packing = r.packing == 0 ? false : true
			this.roles.payment = r.payment == 0 ? false :true
			this.roles.wms = r.wms == 0 ? false :true
			this.roles.platfrom = r.platfrom == 0 ? false : true
			this.roles.report = r.report == 0 ? false :true
			this.roles.product = r.product == 0 ? false : true
			this.roles.delivery = r.delivery == 0 ? false : true
			this.roles.order_return = r.order_return == 0 ? false : true
        },
        async handleUpdate() {
			// Validate
			let valid = await this.$refs.formValidator.validate()
			if (!valid) return

            this.showAddModal = false;
			// update role
			let r = JSON.parse(JSON.stringify(this.roles))
			r.order = this.roles.order == true ? 7 : 0
			r.packing = this.roles.packing == true ? 7 : 0
			r.payment = this.roles.payment == true ? 7 : 0
			r.wms = this.roles.wms == true ? 7 : 0,
			r.platfrom = this.roles.platfrom == true ? 7 : 0
			r.report = this.roles.report == true ? 7 : 0
			r.product = this.roles.product == true ? 7 : 0
			r.delivery = this.roles.delivery == true ? 7 : 0
			r.order_return = this.roles.order_return == true ? 7 : 0

			this.params.roles = JSON.stringify(r)
            // Create

            if (this.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: err.response.data.Cause,
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
				let payload = {
					id:this.id,
					payload : this.params
				}
                this.updateData(payload)
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.fname + " " + row.lname + " ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.UserID)
                        .then(resp => {
                            this.listData();
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
		handleChangePassword(index,row){
			this.params.email = row.email
			this.id = row.UserID
			this.params_password.password = ""
			this.params_password.password_confirm = ""
			this.showChangePasswordModal = true
		},
		handleUpdatePassword(){
			// check password and confirm_password
			if(this.params_password.password != this.params_password.password_confirm){
				swal.fire({
					title: this.$t("password_not_match"),
					text: ``,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return
			}

			let payload = { id: this.id, payload: this.params_password}

			this.changePassword(payload)
                    .then(resp => {
						this.showChangePasswordModal = false
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });


		},

		GetDeaprtmentName(id){
			let name = ""
			this.DepartmentTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}	
			});
			return name
		},
		GetTeamName(id){
			let name = ""
			this.TeamTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}
			});
			return name
		},
		GetStatusName(id){
			let name = ""
			if(id == 2){
				name = "ใช้งาน"
			}else if(id == 3){
				name = "ไม่ใช้งาน"
			}
			return name
		},
		GetUserTypeName(id){
			let name = ""
			this.UserTypeTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}
			});
			return name
		},
		GetSaleChannel(id){
			let name = ""
			this.SaleChannelTable.forEach(element => {
				if(element.id == id){
					name = element.name
				}
			});
			return name
		}
		

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
